export default __webpack_public_path__ + "static/media/pattern2.abb5fe7d.png";